import {httpGet,httpPost,httpJsonp} from '../../../api/base';
import config from '../../../config/config'
const url_pre = config.default_domin;

export default {
	getHomeInfos(params,cb){
		console.log(`${url_pre}/api/fe/v1/private/p/Home`)
		httpPost(`${url_pre}/api/fe/v1/private/p/Home`,params).then((res)=>{
			if(!res){
					cb({errno:110,error:'网络链接错误'})
			}else{
				if(res.data.errno==0){
					cb(res.data.body)
				}else{
					cb(res.data)
				}
			}
		})
	},
	getHolidayPlans(params,cb){
		httpGet(`${url_pre}/api/fe/v1/private/p/Calendar/holiday`,params).then((res)=>{
			if(!res){
					cb({errno:110,error:'网络链接错误'})
			}else{
				if(res.data.errno==0){
					cb(res.data.body)
				}else{
					cb(res.data)
				}
			}
		})
	},
	// 充值 查询公司来源
	saasSearchCorpInfo(params,cb){
		httpGet(`${url_pre}/api/fe/v1/j/saas/search/corpInfo`,params).then((res)=>{
			if(!res){
					cb({errno:110,error:'网络链接错误'})
			}else{
				if(res.data.errno==0){
					cb(res.data.body)
				}else{
					cb(res.data)
				}
			}
		})
	},
}